// Language code mapping
export const LANG_ZH_CN = 'zh-CN'
export const LANG_ZH_HK = 'zh-HK'
export const LANG_EN_HK = 'en-HK'

// OAuth2 constants
export const OAUTH_BASIC = 'Basic YW5kcm9pZC1ib29rbWFya3M6MTIzNDU2'
export const GRANT_TYPE_PASSWORD = 'password'
export const GRANT_TYPE_REFRESH = 'refresh_token'

// Timer constants (seconds)
export const MAX_INACTIVE_CD = 30 * 60     // 30 minutes
export const MAX_REFRESH_TOKEN_CD = 20 * 60 // 20 minutes

// Storage keys
const STORAGE_KEY_TOKEN = 'dcfund_token'
const STORAGE_KEY_REFRESH = 'dcfund_refresh_token'
const STORAGE_KEY_TOKEN_TIME = 'dcfund_token_time'
const STORAGE_KEY_LANGUAGE = 'dcfund_language'

// Session storage for auth tokens
export function getToken() {
  return sessionStorage.getItem(STORAGE_KEY_TOKEN)
}

export function setToken(token) {
  sessionStorage.setItem(STORAGE_KEY_TOKEN, token)
}

export function getRefreshToken() {
  return sessionStorage.getItem(STORAGE_KEY_REFRESH)
}

export function setRefreshToken(token) {
  sessionStorage.setItem(STORAGE_KEY_REFRESH, token)
}

export function getTokenTime() {
  return sessionStorage.getItem(STORAGE_KEY_TOKEN_TIME)
}

export function setTokenTime(time) {
  sessionStorage.setItem(STORAGE_KEY_TOKEN_TIME, String(time))
}

export function clearAuth() {
  sessionStorage.removeItem(STORAGE_KEY_TOKEN)
  sessionStorage.removeItem(STORAGE_KEY_REFRESH)
  sessionStorage.removeItem(STORAGE_KEY_TOKEN_TIME)
}

// LocalStorage for language
export function getLanguage() {
  return localStorage.getItem(STORAGE_KEY_LANGUAGE) || LANG_ZH_CN
}

export function setLanguage(lang) {
  localStorage.setItem(STORAGE_KEY_LANGUAGE, lang)
}
